/**
 * Social profile configuration. Icons render in the footer ONLY when a real
 * https URL is configured, so the site never ships dead "#" social buttons.
 * When the accounts are created, set the env vars below at build time (they
 * are baked in via vite define constants) and the icons appear.
 *
 *   VITE_SOCIAL_GITHUB     e.g. https://github.com/nuvra
 *   VITE_SOCIAL_X          e.g. https://x.com/nuvra
 *   VITE_SOCIAL_LINKEDIN   e.g. https://www.linkedin.com/company/nuvra
 *   VITE_SOCIAL_COMMUNITY  e.g. a Discord or forum invite URL
 */

declare const __SOCIAL_GITHUB__: string | undefined;
declare const __SOCIAL_X__: string | undefined;
declare const __SOCIAL_LINKEDIN__: string | undefined;
declare const __SOCIAL_COMMUNITY__: string | undefined;

function defined(v: string | undefined): string {
  return typeof v === "string" ? v.trim() : "";
}

export interface SocialLink {
  id: "github" | "x" | "linkedin" | "community";
  label: string;
  url: string;
}

/** Only entries with a configured, non-empty https URL are returned. */
export function getConfiguredSocialLinks(): SocialLink[] {
  const all: SocialLink[] = [
    { id: "github",    label: "GitHub",    url: defined(typeof __SOCIAL_GITHUB__    === "undefined" ? "" : __SOCIAL_GITHUB__) },
    { id: "x",         label: "X",         url: defined(typeof __SOCIAL_X__         === "undefined" ? "" : __SOCIAL_X__) },
    { id: "linkedin",  label: "LinkedIn",  url: defined(typeof __SOCIAL_LINKEDIN__  === "undefined" ? "" : __SOCIAL_LINKEDIN__) },
    { id: "community", label: "Community", url: defined(typeof __SOCIAL_COMMUNITY__ === "undefined" ? "" : __SOCIAL_COMMUNITY__) },
  ];
  return all.filter(s => /^https:\/\//.test(s.url));
}
